const binding = { modules: {}, dataActions: {} };

    (binding.modules['eve-form-input'] = {
        c: () => require('partner/modules/eve-form-input/eve-form-input.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-form-input',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-form-input'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eve-form-input|eve-form-input'] = {
                c: () => require('partner/modules/eve-form-input/eve-form-input.view.tsx'),
                cn: '__local__-__local__-eve-form-input'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };